import { supabase } from '../lib/supabase'

/**
 * Gestión de la lista de correos suscritos a las alertas de tickets
 * (nuevos / sin asignar). Tabla: Tickets.notificationSubscriber.
 * @namespace notificationSubscriberService
 */
const notificationSubscriberService = {
  schemaName: 'Tickets',
  tableName: 'notificationSubscriber',

  async getAll() {
    try {
      const { data, error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .select('*')
        .order('createdAt', { ascending: false })
      if (error) throw error
      return { success: true, data }
    } catch (error) {
      console.error('Error fetching subscribers:', error)
      return { success: false, data: null, error: error.message }
    }
  },

  async create(subscriber) {
    try {
      const { data, error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .insert([subscriber])
        .select()
        .single()
      if (error) throw error
      return { success: true, data }
    } catch (error) {
      console.error('Error creating subscriber:', error)
      return { success: false, data: null, error: error.message }
    }
  },

  async update(id, updates) {
    try {
      const { data, error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .update(updates)
        .eq('id', id)
        .select()
        .single()
      if (error) throw error
      return { success: true, data }
    } catch (error) {
      console.error('Error updating subscriber:', error)
      return { success: false, data: null, error: error.message }
    }
  },

  async remove(id) {
    try {
      const { error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .delete()
        .eq('id', id)
      if (error) throw error
      return { success: true }
    } catch (error) {
      console.error('Error deleting subscriber:', error)
      return { success: false, error: error.message }
    }
  },
}

export default notificationSubscriberService
